import { FullCompany } from "../../../types/models/company/company.types";
import { PlanENT } from "../../../types/models/plans/plans.types";
import { COMPANY_ENDPOINTS } from "../../../utils/api/endpoints/companyEndpoints";

const PREFIX = '[fullCompanyQuery]';

export const queryFullCompany = async (userId: number) => {
  console.log(PREFIX, `Fetching company infos...`);
  const response = await COMPANY_ENDPOINTS.getFull(userId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received company infos.`);
  return json as FullCompany & PlanENT;
};
